import { useState, useRef, useEffect } from "react";
import { HiDotsVertical } from "react-icons/hi";

export default function ActionMenu({ actions = [] }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block" ref={menuRef}>
      {/* Trigger */}
      <button
        onClick={() => setOpen(!open)}
        className="p-2 rounded-full hover:bg-gray-100"
      >
        <HiDotsVertical className="w-5 h-5 text-gray-700" />
      </button>

      {/* Menu */}
      {open && (
        <div className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-lg border border-gray-200 z-50">
          {actions.map((action, index) => (
            <button
              key={index}
              onClick={() => {
                setOpen(false);
                action.onClick && action.onClick();
              }}
              className={`
                w-full flex items-center gap-3 px-4 py-3 text-sm
                hover:bg-gray-100
                ${action.danger ? "text-red-600" : "text-gray-800"}
                ${index === 0 ? "rounded-t-xl" : ""}
                ${index === actions.length - 1 ? "rounded-b-xl" : ""}
              `}
            >
              <span className="text-lg">{action.icon}</span>
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
